import React from 'react';
import moment from 'moment';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';
import skeletonTableLoader from '../../../shared/components/custom/SkeletonLoaders';
import { partial } from '../../../util/translation/translation';

const formatHourTick = (hour) => moment(hour).format('DD MMM HH:mm');

const HourlyUsersChart = ({ data, isLoading }) => {
  const a = partial('Analytics');

  return (
    <div style={{ height: '350px' }}>
      {isLoading ? (
        <div className="d-flex justify-content-center align-items-center h-100">
          {skeletonTableLoader(1, 1, 750)}
        </div>
      ) : data.length === 0 ? (
        <div className="d-flex justify-content-center align-items-center h-100">
          <p className="">{a('noData')}</p>
        </div>
      ) : (
        <ResponsiveContainer width="100%" height="100%">
          <LineChart
            data={data}
            margin={{ top: 10, right: 30, left: 0, bottom: 0 }}
          >
            <CartesianGrid
              strokeDasharray="3 3"
              stroke="#e0e0e0"
              vertical={false}
            />
            <XAxis
              dataKey="hour"
              tickFormatter={formatHourTick}
              tickLine={false}
              axisLine={false}
              tick={{ fill: '#666', fontSize: 11 }}
              minTickGap={30}
            />
            <YAxis
              tickLine={false}
              axisLine={false}
              tick={{ fill: '#666', fontSize: 12 }}
            />
            <Tooltip
              labelFormatter={formatHourTick}
              contentStyle={{
                background: 'white',
                border: '1px solid #e0e0e0',
                borderRadius: '4px',
                boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
              }}
            />
            <Legend />
            <Line
              type="monotone"
              dataKey="allUserCount"
              name={a('sessions')}
              stroke="#007bff"
              strokeWidth={2}
              dot={{ r: 0 }}
              activeDot={{
                r: 5,
                stroke: '#007bff',
                strokeWidth: 1,
                fill: 'white',
              }}
            />
            <Line
              type="monotone"
              dataKey="uniqueUserCount"
              name={a('activeUsers')}
              stroke="#000000"
              strokeWidth={2}
              dot={{ r: 0 }}
              activeDot={{
                r: 5,
                stroke: '#000000',
                strokeWidth: 1,
                fill: 'white',
              }}
            />
          </LineChart>
        </ResponsiveContainer>
      )}
    </div>
  );
};

export default HourlyUsersChart;
